import { push } from "connected-react-router"
import Cookies from "js-cookie"
import { put, select } from "redux-saga/effects"
import URI from "urijs"

import api from "apis"
import { splitName } from "helpers/name"

import { doLogin, setExplicitLogin, setLoginNotification } from "../actions"

export default function* submitRegistration(actions) {
  try {
    const state = yield select()
    const query = URI.parseQuery(state.router.location.search)

    const values = actions.values
    let params = {
      cart_token: Cookies.get(sl.config.cookies_config.cart_token),
      email: values.email,
      password: values.password,
      subscribe_vip: values.subscribe_vip,
      wishlist_token: Cookies.get(sl.config.cookies_config.wishlist_token),
    }
    yield put(setExplicitLogin())

    // For inserting register route params
    // Params: orderNumber, 'register' flag, fullName, phone
    if (values.orderNumber) {
      params.cert_number = values.orderNumber
      if (!values.registered) {
        let nameSplit = splitName(values.fullName)
        params.first_name = nameSplit.first
        params.last_name = nameSplit.last
        if (!params.last_name) {
          console.error("Must include last name.")
          yield put(setLoginNotification("Must include last name."))
        }
        params.phone = values.phone
        params.registered = values.registered
        console.log("last reg path params: ", params)
      }
    }
    params.order_token = query.order_token
    const result = yield api.post("/api/v10/signup", params)

    if (result?.data) {
      yield put(setLoginNotification(null))
      // if (query.order_token && query.order_token !== "") {
      //   yield put(replace(`${location.pathname}${location.search}`))
      // }
      if (result.data.redirect) {
        yield put(push(result.data.redirect))
      } else {
        yield put(doLogin(result.data, "jewlrorders"))

        // Only redirect to register/success page if for warranty registration
        if (values.orderNumber) {
          yield put(push("/register/success"))
        }
      }

      if (window.location.href.includes("/signup")) {
        yield put(push("/account"))
      }
    }
  } catch ({ errors }) {
    console.error("REGISTRATION CB ERROR", errors)
    if (actions.action && actions.action.setStatus) {
      actions.action.setStatus({ errors })
    }
  }
  actions.setSubmitting(false)
}
